import styled from "styled-components";

export const CustomButton = styled.button`
  width: ${(props) => props.width || "150px"};
  height: ${(props) => props.height || "40px"};
  background: ${(props) => props.background || "#6CAEFF"};
  border-radius: ${(props) => props.radius || "8px"};
  border-width: ${(props) => props.borderSize || "1px"};
  border-color: ${(props) => props.borderColor || "#6CAEFF"};
  border-style: ${(props) => props.style || "solid"};
  color: ${(props) => props.color || "#fff"};
  padding-right: 8px;
  padding-left: 8px;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 500};
  font-size: ${(props) => props.fontSize || "16px"};
  line-height: 21px;
  margin-top: ${(props) => props.marginTop};
  text-align: center;
  word-wrap: break-word;
  cursor: pointer;
  transition: 0.7s;
  direction: rtl;
  &:hover {
    opacity: 0.7;
  }
  &.disabled {
    background-color: gray;
    opacity: 0.5;
    border-color: gray;
    &:hover {
      cursor: not-allowed;
      color: ${(props) => props.colorHover || "#FFF"};
    }
  }
  @media (max-width: 1024px) {
    height: ${(props) => props.height1024};
  }
  @media (max-width: 417px) {
    width: ${(props) => props.width417};
  }
  @media (max-width: 360px) {
    width: ${(props) => props.width360 || "150x"};
  }
`;

export const WalletValue = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: ${(props) => props.color || "#27548c"};
  text-align: right;
`;
